import React from "react";
import { useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";
import { CELL_SIZE } from "../../helpers/consts";
import { spriteSheetImageAtom } from "../../atoms/spriteSheetImageAtom";

function Sprite({ frameCoord, size = CELL_SIZE }) {
  const spriteSheetImage = useRecoilValue(spriteSheetImageAtom);
  const canvasRef = useRef();
  useEffect(() => {
    // Grab a reference to the canvas
    /** @type {HTMLCanvasElement} */
    const canvasEl = canvasRef.current;
    const ctx = canvasEl.getContext("2d");

    // Clear anything currently present
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    const tileSheetX = Number(frameCoord.split("x")[0]);
    const tileSheetY = Number(frameCoord.split("x")[1]);

    ctx.drawImage(
      spriteSheetImage,
      tileSheetX * CELL_SIZE, // Left X corner of frame
      tileSheetY * CELL_SIZE, // Top Y corner of frame
      size, //How much to crop from the sprite sheet (X)
      size, //How much to crop from the sprite sheet (Y)
      0, //Where to place this on canvas tag X (0)
      0, //Where to place this on canvas tag Y (0)
      size, //How large to scale it (X)
      size //How large to scale it (Y)
    );
  }, [frameCoord, spriteSheetImage, size]);

  return <canvas width={size} height={size} ref={canvasRef} />;
}

//Memoize to only render on frameCoord or size changes
const MemoizedSprite = React.memo(Sprite);

export default MemoizedSprite;
